import ProfileTemplate from "components/templates/ProfileTemplate/ProfileTemplate";

const ProfilePage = () => {
  return <ProfileTemplate />;
};

export default ProfilePage;
